<template>
  <div class="consumables-container">
    <div v-for="(consumable, index) in items" :key="index" class="consumable">
      <span class="consumable-name">{{ consumable.name[lang] }}</span>
      <span class="dotted-line"></span>
      <span class="consumable-price">{{ consumable.price }}</span>
    </div>
    <div class="category-description pt-8">{{description}}</div>
    <div class="flex justify-center items-center">
      <p class="font-bold">{{$t('priceWithoutIva')}} ( 10% )</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items", "description"],
  data: () => {
    return {
      lang: window.appLocale,
    };
  },
};
</script>

<style lang="scss">
@import "../../../sass/variables";

.consumables-container{
    width: 100%;
    margin: 50px auto;
    color: $rouge;
    @media(min-width: 1024px){
      max-width: 700px;
      margin: 70px auto 100px;
    }

    .category-description {
      text-align: center;
    }

    .consumable{
        margin-top: 21px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:first-child{
            margin-top: 0;
        }

        .consumable-name {
            max-width: 75%;
            text-align: justify;
            flex-grow: 0;

            @media (min-width: 640px) {
                max-width: 80%;
            }
        }

        .dotted-line{
          position: relative;
          display: flex;
          flex:1;
          margin: 0 0.6rem 0 1rem;
          min-width: 1.25rem;
          &:after{
            content: "";
            position: absolute;
            width: 100%;
            bottom: 48%;
            left: 0;
            border-bottom-width: 1px;
            border-color: $rouge;
            border-style: dashed;
          }
        }

        .consumable-price {
            min-width: 4.25rem;
            text-align: right;
        }
    }
}
</style>
